module.exports = __webpack_public_path__ + "img/audi2.81ac92ed.jpg";